// extracted by mini-css-extract-plugin
export default {"closeButton":"CloseButton_closeButton__n+3F+","firstLine":"CloseButton_firstLine__AXhWb","secondLine":"CloseButton_secondLine__JAPTG"};